<template>
  <div class="login-page">
    <!-- Textura de fondo sutil: líneas de calibración, no blobs ni partículas -->
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="login-shell">
      <!-- Etiqueta tipo "placa" -->
      <div class="tag-eyebrow fade-in">
        <span class="tag-dot"></span>
        BAMBOO&nbsp;/&nbsp;Management
      </div>

      <div class="login-card fade-in-up">
        <!-- Regla de calibración: elemento firma -->
        <div class="ruler" aria-hidden="true">
          <span
            v-for="n in 12"
            :key="n"
            class="tick"
            :class="{ major: n % 4 === 0 }"
          ></span>
        </div>

        <div class="login-card-inner">
          <!-- Header -->
          <div class="login-head">
            <v-img
              :src="logoBambo"
              contain
              width="140"
              class="login-logo"
            ></v-img>
            <h1 class="login-title">Iniciar sesión</h1>
            <p class="login-sub">Panel de administración del gimnasio</p>
          </div>

          <!-- Formulario -->
          <form class="login-form" @submit.prevent="iniciarSesion">
            <div class="field">
              <label class="field-label" for="usuario">Usuario</label>
              <input
                id="usuario"
                v-model="usuario"
                type="text"
                class="field-input"
                placeholder="tu.usuario"
                autocomplete="username"
              />
            </div>

            <div class="field">
              <div class="field-label-row">
                <label class="field-label" for="password">Contraseña</label>
                <button
                  type="button"
                  class="field-toggle"
                  @click="showPassword = !showPassword"
                >
                  {{ showPassword ? "Ocultar" : "Mostrar" }}
                </button>
              </div>
              <input
                id="password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                class="field-input"
                placeholder="••••••••"
                autocomplete="current-password"
              />
            </div>

            <button type="submit" class="submit-btn" :disabled="loading">
              <span v-if="!loading">Ingresar</span>
              <span v-else class="submit-loading">
                <span class="spinner"></span>
                Autenticando
              </span>
            </button>

            <div class="login-links">
              <button type="button" class="link-btn" @click="abrirSoporte">
                Soporte
              </button>
              <span class="link-sep">·</span>
              <button type="button" class="link-btn" @click="abrirContacto">
                Contacto
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="login-footer">
        Bamboo Management Suite — v2.0.0 · Coded by PandaCode ©
        {{ new Date().getFullYear() }}
      </div>
    </div>

    <!-- Snackbar -->
    <v-snackbar
      v-model="mostrarMensaje"
      :color="mensaje.color"
      :timeout="3000"
      right
      top
    >
      {{ mensaje.texto }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="mostrarMensaje = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import logoBambo from "@/assets/img/LOGOBAMBO.png";

export default {
  name: "Login",

  data: () => ({
    logoBambo,
    usuario: "",
    password: "",
    mensaje: {
      texto: "",
      color: ""
    },
    mostrarMensaje: false,
    showPassword: false,
    loading: false
  }),

  created() {
    if (this.$store.getters.isLoggedIn) {
      this.redireccionarPorRol(this.$store.getters.userRole);
    }
  },

  methods: {
    iniciarSesion() {
      if (!this.usuario || !this.password) {
        this.mostrarMensaje = true;
        this.mensaje.texto = !this.usuario
          ? "Debes colocar el usuario"
          : "Debes colocar la contraseña";
        this.mensaje.color = "warning";
        return;
      }

      this.loading = true;

      const payload = {
        metodo: "login",
        usuario: {
          usuario: this.usuario,
          password: this.password
        }
      };

      HttpService.obtenerConDatos(payload, "usuarios.php")
        .then(resultado => {
          this.loading = false;
          if (resultado && resultado.resultado) {
            const rol = resultado.datos.rol.toLowerCase();
            localStorage.setItem("idUsuario", resultado.datos.idUsuario);
            localStorage.setItem("rol", resultado.datos.rol);
            localStorage.setItem("usuario", resultado.datos.nombreUsuario);

            this.$store.commit("setUser", resultado.datos);
            this.redireccionarPorRol(rol);
          } else {
            this.mostrarMensaje = true;
            this.mensaje.texto = "Usuario o contraseña incorrectos";
            this.mensaje.color = "error";
          }
        })
        .catch(() => {
          this.loading = false;
          this.mostrarMensaje = true;
          this.mensaje.texto = "Error de conexión";
          this.mensaje.color = "error";
        });
    },

    redireccionarPorRol(rol) {
      switch (rol) {
        case "admin":
        case "administrador":
          this.$router.replace("/dashboard");
          break;
        case "empleado":
          this.$router.replace("/registrar-visita");
          break;
        default:
          this.mostrarMensaje = true;
          this.mensaje.texto = "No tienes permisos para acceder.";
          this.mensaje.color = "error";
      }
    },

    abrirSoporte() {
      this.mostrarMensaje = true;
      this.mensaje.texto = "Envíanos un mensaje a nava.saidalfredo@gmail.com";
      this.mensaje.color = "info";
    },

    abrirContacto() {
      this.mostrarMensaje = true;
      this.mensaje.texto = "Contáctanos mediante Whatsapp al 3531015780";
      this.mensaje.color = "error";
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap");

/* ===== TOKENS ===== */
.login-page {
  --bg: #0e0e10;
  --card: #17171a;
  --card-border: #26262a;
  --text-primary: #f2f2ed;
  --text-secondary: #8c8c93;
  --text-tertiary: #5c5c62;
  --accent: #c8ff4d;
  --accent-dim: rgba(200, 255, 77, 0.14);
  --error: #ff6b6b;
  --radius: 4px;

  --font-display: "Space Grotesk", sans-serif;
  --font-body: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: "JetBrains Mono", monospace;
}

.login-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 32px 20px;
}

/* Textura sutil de calibración, no decorativa-ruidosa */
.bg-grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
      rgba(242, 242, 237, 0.028) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(242, 242, 237, 0.028) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(
    ellipse 70% 60% at 50% 40%,
    black 30%,
    transparent 75%
  );
  pointer-events: none;
}

.login-shell {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ===== EYEBROW TAG ===== */
.tag-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.14em;
  color: var(--text-secondary);
  margin-bottom: 20px;
}

.tag-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 8px var(--accent);
}

/* ===== CARD ===== */
.login-card {
  position: relative;
  width: 100%;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  display: flex;
  overflow: hidden;
}

/* Regla de calibración vertical — elemento firma */
.ruler {
  width: 18px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
  padding: 24px 0;
  border-right: 1px solid var(--card-border);
  background: rgba(255, 255, 255, 0.012);
}

.tick {
  width: 6px;
  height: 1px;
  background: var(--text-tertiary);
  margin-right: 6px;
}

.tick.major {
  width: 11px;
  background: var(--accent);
}

.login-card-inner {
  flex: 1;
  padding: 40px 32px;
  min-width: 0;
}

/* ===== HEAD ===== */
.login-head {
  margin-bottom: 32px;
}

.login-logo {
  margin-bottom: 20px;
  filter: grayscale(1) brightness(1.6);
  opacity: 0.92;
}

.login-title {
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0 0 6px;
  color: var(--text-primary);
}

.login-sub {
  font-size: 13.5px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== FORM ===== */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.field-toggle {
  background: none;
  border: none;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 0;
  transition: color 0.15s ease;
}

.field-toggle:hover {
  color: var(--accent);
}

.field-input {
  width: 100%;
  background: #0e0e10;
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 12px 14px;
  font-size: 14.5px;
  font-family: var(--font-body);
  color: var(--text-primary);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.field-input::placeholder {
  color: var(--text-tertiary);
}

.field-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-dim);
}

/* ===== SUBMIT ===== */
.submit-btn {
  margin-top: 6px;
  width: 100%;
  background: var(--accent);
  color: #0e0e10;
  border: none;
  border-radius: var(--radius);
  padding: 13px;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.1s ease;
}

.submit-btn:hover:not(:disabled) {
  filter: brightness(1.08);
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.99);
}

.submit-btn:disabled {
  opacity: 0.65;
  cursor: default;
}

.submit-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 13px;
  height: 13px;
  border: 2px solid rgba(14, 14, 16, 0.3);
  border-top-color: #0e0e10;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== LINKS ===== */
.login-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  padding-top: 18px;
  border-top: 1px solid var(--card-border);
}

.link-btn {
  background: none;
  border: none;
  font-size: 12.5px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  transition: color 0.15s ease;
}

.link-btn:hover {
  color: var(--text-primary);
}

.link-sep {
  color: var(--text-tertiary);
  font-size: 12px;
}

/* ===== FOOTER ===== */
.login-footer {
  margin-top: 28px;
  font-family: var(--font-mono);
  font-size: 10.5px;
  letter-spacing: 0.03em;
  color: var(--text-tertiary);
  text-align: center;
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.5s ease both;
}

.fade-in-up {
  animation: fadeInUp 0.5s ease 0.05s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in,
  .fade-in-up,
  .spinner {
    animation: none;
  }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 480px) {
  .login-card-inner {
    padding: 28px 20px;
  }

  .ruler {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Usuarios/Login.vue